import { render } from "./TheTheme.vue?vue&type=template&id=65e345b8"
const script = {}
script.render = render

export default script